<template>
    <div :class="rootClasses">
        <div v-if="showBootLoader" class="loader-overlay">
            <div class="spinner-border spinner-border-reverse align-self-center loader-lg text-secondary">Loading...</div>
        </div>
        <component :is="layoutComponent" />
    </div>
</template>

<script setup>
import { computed, defineAsyncComponent, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useMeta } from './composables/use-meta';
import { useLayout } from '@/composables/useLayout';
import {
    ensureFullAppStyles,
    isSalesInscricaoPath,
    routeNeedsFullAppStyles,
} from '@/bootstrap/appBoot';

import './assets/sass/sales-shell.scss';

useMeta({ title: 'Descomplique sua correção' });

const store = useStore();
const route = useRoute();
const { layoutState } = useLayout();

const AppLayout = defineAsyncComponent(() => import('./layouts/app-layout.vue'));
const SalesLayout = defineAsyncComponent(() => import('./layouts/sales-layout.vue'));

const isLoading = computed(() => store.getters.isLoading);
const layoutName = computed(() => {
    if (store.state.layout) {
        return store.state.layout;
    }
    return isSalesInscricaoPath() ? 'sales' : 'app';
});
const showBootLoader = computed(() => isLoading.value && layoutName.value === 'app');
const layoutComponent = computed(() => {
    if (layoutName.value === 'sales') return SalesLayout;
    return AppLayout;
});
const rootClasses = computed(() => {
    if (layoutName.value === 'sales') {
        return 'sales-root';
    }
    return [layoutState.value.layoutStyle, layoutState.value.menuStyle];
});

if (routeNeedsFullAppStyles({ meta: { layout: layoutName.value } })) {
    ensureFullAppStyles();
}

watch(
    () => [layoutName.value, route.name, route.meta?.layout],
    () => {
        if (routeNeedsFullAppStyles(route) || layoutName.value !== 'sales') {
            ensureFullAppStyles();
        }
    },
);
</script>
